export const NO_DATA_ERROR =
  "We're sorry, there was a problem with your search. Go to  <a class='text-link' href='https://carsandstays.delta.com/?MDPCID=Delta-US.DPS.Delta.Homepage-Bellyband.AllLOB#.' target='_blank'>Delta Stays</a> and try searching again.";
